import { render, staticRenderFns } from "./QuestionsSubmenu.vue?vue&type=template&id=0671fa58"
import script from "./QuestionsSubmenu.vue?vue&type=script&lang=js"
export * from "./QuestionsSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports